<div class="d-flex component">
  <div [id]="chartId" class="load-factor-chart-container mr-3"></div>
  <div>
    @if (loadFactor) {
      <div class="font-weight-bold text-start font-size-normal text-primary">
        <span class="font-weight-bold text-start font-size-normal text-primary"
          [innerHTML]="loadFactor | number : digitsInfo | customNumberFormat | smallDecimal: 'font-weight-bold'">
        </span> %
      </div>
    }
    @if (!loadFactor) {
      <div class="font-weight-bold font-size-verysmall text-start">
        -
      </div>
    }
    <div class="text-start font-size-verysmall">
      {{displayName | translate}}
    </div>
  </div>
</div>
